export default {
  hasTouch() {
    return (navigator.maxTouchPoints > 0)
      || (navigator.msMaxTouchPoints > 0)
      || (navigator.maxTouchPoints === undefined && window.TouchEvent !== undefined);
  },
  clamp(number, min, max) {
    return Math.max(min, Math.min(number, max));
  },
  trim(str) {
    return str.toString().replace(/\s+/g, '');
  },
  isBrightHSL(hslColor) {
    // MAKE THIS WORK WITH ALL Colors  - use w3c color stuff
    return this.trim(hslColor).split(',')[2].split('%')[0] > 80;
  },
};
